import { useMemo, useRef, useState } from 'react';
import { ColDef, ColumnState, RowClickedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { GridContextWrapper } from 'src/components/common/gridWrapper/GridContextWrapper';
import Grid_Select from 'src/components/common/gridWrapper/Grid_Select';
import { PDA1040_R01HeaderDto } from 'src/containers/PDA/PDA1040_R01/PDA1040_R01Dto';
import {
  aggridHeaderClass,
  pdaCellStyle,
} from 'src/components/common/common';

interface PDA1040_R01OrderListProps {
  orders: PDA1040_R01HeaderDto[];
  onSelectOrder: (order: PDA1040_R01HeaderDto) => void;
}

type PDA1040_R01HeaderDtoWithInserted = PDA1040_R01HeaderDto & { inserted?: boolean };

const PDA1040_R01OrderList: React.FC<PDA1040_R01OrderListProps> = ({
  orders,
  onSelectOrder,
}) => {
  const gridRef = useRef<AgGridReact<PDA1040_R01HeaderDtoWithInserted>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);
  const [columnState, setColumnState] = useState<ColumnState[] | null>(null);

  const paddedGridData = useMemo(() => {
    const data: PDA1040_R01HeaderDtoWithInserted[] = [...orders];
    return data;
  }, [orders]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: '발주일자',
        field: 'orderDt',
        valueGetter: (params) => params.data?.orderDt || '-',
        cellStyle: { 
          textAlign: 'center', 
          ...pdaCellStyle,
          justifyContent: 'center'
        },
        headerClass: aggridHeaderClass,
        flex: 1,
        minWidth: 100,
      },
      {
        headerName: '상호',
        field: 'customNm',
        valueGetter: (params) => params.data?.customNm || '-',
        cellStyle: { 
          textAlign: 'left', 
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 1.5,
        minWidth: 120,
      },
      {
        headerName: '발주번호',
        field: 'purchaseOrderNo',
        valueGetter: (params) => params.data?.purchaseOrderNo || '-',
        cellStyle: { 
          textAlign: 'left', 
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 2,
        minWidth: 100,
      },
    ] as ColDef<PDA1040_R01HeaderDtoWithInserted>[],
    []
  );

  const initSelected = () => {};

  const onRowClicked = (event: RowClickedEvent<PDA1040_R01HeaderDtoWithInserted>) => {
    if (event.data) {
      onSelectOrder(event.data);
    }
  };

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={initSelected}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1040_R01_OrderList_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<PDA1040_R01HeaderDtoWithInserted>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1040_R01_OrderList_ColumnState"
            setColumnState={setColumnState}
            onRowClicked={onRowClicked}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1040_R01OrderList;
